import React, { Component } from 'react';
import sumBy from 'lodash/sumBy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import BigText from '../../../../components/LazyWidgets/BigText';
import s from './ModuleOverview.module.css';
import style from '../../../../components/UnitCards/UnitCards.module.css';
import ReportError from '../ReportError';
import moduleComponent from './moComponents/HeroCard/moduleHighlightsComponent';
import { refreshReport as refreshReportAction, sendAnalyticsEvent } from '../../../actions/reports';
import { REPORT_KEYS, REPORT_TYPES } from '../../../actions/constants';
import PerformanceByUnitComponent from './moComponents/performanceByUnitComponent';
import PerformanceByStudentComponent from '../QuantQual/qqComponents/performanceByStudentComponent';
import performanceByLearningObjectiveComponent from '../QuantQual/qqComponents/performanceByLearningObjectiveComponent';
import ExternalFrameworkCard from '../../../../components/ExternalFrameworkCard';
import { getConfigObject } from '../../../util/config';

class ModuleOverview extends Component {

  componentDidMount() {
    this.props.refreshReport(REPORT_KEYS.unitOverview);
  }

  getUnitCardContent(unit) {
    const cftText = unit.correctOnFirstTry > 0 ? `${Math.round(unit.correctOnFirstTry * 100)}%` : '0%';

    return (<div className={style.scoreContainer}>
      {!unit.notStarted && <div className={style.unitStudentAnswer}>Students Answered</div>}
      {!unit.notStarted ? <BigText className={style.bigText} text={cftText} alignment="center" />
        : <BigText className={style.notStarted} text="Not Started" alignment="center" />}
      {!unit.notStarted && <div className={style.unitStudentAnswer}>of Questions Correctly On Their First Try</div>}
    </div>);
  }

  getModalContent() {
    return (
      <div>
        <p><b>Assignments Completed</b> represents the number of assignments the individual students has completed out of the total number of resources assigned to the student in this Course.<br /></p>
        <p><b>Achievement on completion assignments (practice/homework)</b> represents the proportion of questions in this Course completed by the student across all assignments in this Course that define achievement by a student completing the assignment (i.e. practice tests and homework assignments where students are granted multiple attempts per question).<br /></p>
        <p><b>Achievement on proficiency assignments (quizzes/test)</b> represents the proportion of questions in this Course that a student got correct across all assignments that define achievement by proficiency (i.e. quizzes and test where students are granted only one attempt per question).</p>
      </div>
    );
  }

  render() {
    if (this.props.loading) {
      return (
        <div className={s.loadingWrapper}>
          <div className={s.loadingContainer}>
            <Spinner className={s.mlLoading} />
          </div>
        </div>);
    }

    const {
      reports: {
        unitOverview: {
          error,
          activeUnit,
          hasStudents,
          performanceByExternalFrameworks,
          performanceByUnit,
          performanceByLearningObjective,
          performanceByStudent,
        },
      },
      onTabChange,
      reportType,
    } = this.props;

    if (error) return <ReportError />;

    const { DASHBOARD_ENABLED_QQ_MODULE_REPORT, FEATURE_USE_EXTERNAL_INSIGHTS } = getConfigObject();

    const numAssignments = sumBy(performanceByUnit, 'assignments') || 0;

    return (
      <div className={s.moduleOverviewContainer}>
        {moduleComponent({
          unitActive: activeUnit,
          hasStudents,
          onTabChange,
          showModuleReportButton: DASHBOARD_ENABLED_QQ_MODULE_REPORT && activeUnit && !activeUnit.notStarted,
        })}
        {performanceByUnit &&
          <PerformanceByUnitComponent
            data={performanceByUnit}
            onTabChange={onTabChange}
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
          />
        }
        {FEATURE_USE_EXTERNAL_INSIGHTS &&
          <ExternalFrameworkCard
            rows={performanceByExternalFrameworks}
            reportType={reportType}
          />
        }
        {performanceByLearningObjective && performanceByLearningObjectiveComponent(performanceByLearningObjective, hasStudents, onTabChange, REPORT_TYPES.unit)}
        {performanceByStudent &&
          <PerformanceByStudentComponent
            data={performanceByStudent}
            assignments={numAssignments}
            onTabChange={onTabChange}
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
            modalContent={this.getModalContent()}
            buildReportUrl={studentId => `reports/type/student-overview/${studentId}`}
          />}
      </div>
    );
  }
}

ModuleOverview.propTypes = {
  history: PropTypes.object,
  onTabChange: PropTypes.func,
  reportType: PropTypes.string,
  refreshReport: PropTypes.func,
  reports: PropTypes.object,
  loading: PropTypes.bool,
};

const mapDispatchToProps = dispatch => bindActionCreators({ refreshReport: refreshReportAction, sendAnalyticsEvent }, dispatch);

function mapStateToProps(state) {
  return {
    reports: state.reports,
    loading: !state.reports.courseAbstract || state.reports.courseAbstract.loading || !state.reports.unitOverview || state.reports.unitOverview.loading,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuleOverview);
